module.exports = __webpack_public_path__ + "static/Algemene-voorwaarden-NOM_v2026-09-01-81463bdd7ef1b6ef8c90e8de6b7c4e42.pdf";